type TrustpilotConfig = {
  locale: string;
  businessunitId: string;
  href: string;
};

export default function getTrustpilotConfig(
  contentfulLocale: string
): TrustpilotConfig {
  switch (contentfulLocale) {
    case 'nb-NO':
      return {
        locale: 'nb-NO',
        businessunitId: '632c0c89acc254ca8727ef7f',
        href: 'https://no.trustpilot.com/review/lanna.no',
      };

    default:
      return {
        locale: 'sv-SE',
        businessunitId: '5c7e4a55b62d9a000147ad68',
        href: 'https://se.trustpilot.com/review/lannamobler.se',
      };
  }
}
